export default __webpack_public_path__ + "static/media/ic-unseen.bc9b643f.svg";